import { render, staticRenderFns } from "./TaskHeadUer.vue?vue&type=template&id=69c44dea"
import script from "./TaskHeadUer.vue?vue&type=script&lang=js"
export * from "./TaskHeadUer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports